import {Bar} from 'vue-chartjs';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import maxBy from 'lodash/maxBy';
import join from 'lodash/join'
import chartjsPluginAnnotation from "chartjs-plugin-annotation";
import forEach from 'lodash/forEach';
import {mapGetters} from 'vuex';

export default {
  name: 'BarChart',
  extends: Bar,
  props: {
    linedatasets: {
      required: false,
      type: [Object, Array],
    },
    withLabels: {
      required: false,
      type: [Boolean],
      default: false,
    },
    showLegend: {
      required: false,
      type: [Boolean],
      default: true,
    },
    bardatasets: {
      required: true,
      type: [Object, Array],
    },
    scaleLabelY: {
      required: false,
      type: [String],
      default: "",
    },
    scaleLabelX: {
      required: false,
      type: [String],
      default: "",
    },
    aspectRatio: {
      required: false,
      type: [Boolean],
      default: true,
    },
    verticalLinePoint: {
      required: false,
      type: [Array, Object],
      default: null
    },
    valueMax: {
      required: false,
      type: [Number, String],
      default: null,
    },

  },
  mounted() {
    this.render();
  },
  plugins: [ChartDataLabels, chartjsPluginAnnotation],
  computed: {
    ...mapGetters('mobile', [
      'isMobile',
    ]),
  },
  methods: {
    render() {

      let maxBarDatasets = 0;
      let maxLineDatasets = 0;
      if (this.bardatasets){
        let maxB = 0;
        if (this.bardatasets.data){
          maxB = maxBy(this.bardatasets.data, function(item) { return item.y; });
        } else if (this.bardatasets[0]){
          maxB = maxBy(this.bardatasets[0].data, function(item) { return item.y; });
        }
        if(maxB){
          maxBarDatasets = (maxB.y*1.1 < 100) ? maxB.y*1.1 : maxB.y
        }
      }
      if (this.linedatasets){
        let maxL = maxBy(this.linedatasets.data ?  this.linedatasets.data : this.linedatasets[0].data, function(item) { return item.y; });
        if (maxL){
          maxLineDatasets = (maxL.y*1.1 < 100) ? maxL.y*1.1 : maxL.y
        }
      }
      let max = (maxBarDatasets - maxLineDatasets > 0) ? maxBarDatasets : maxLineDatasets;
      let valueMax = this.valueMax;

      let pointArray = [];

      if (this.verticalLinePoint){
        forEach (this.verticalLinePoint, (point,index) =>{
          pointArray.push({
            id: "vertLine"+index,
            type: "line",
            mode: "vertical",
            scaleID: "x-axis-0",
            value: point.x,
            borderColor: "black",
            borderDash: point.isImportant ?  0 : [5, 5],
            borderWidth: 2,
            onMouseover: function(e) {
              let element = this;
              //element.options.label.content = '';
              let tooltipEl = document.getElementById('chartjs-tooltip-vertical');

              if (!tooltipEl) {
                tooltipEl = document.createElement('div');
                tooltipEl.id = 'chartjs-tooltip-vertical';
                element.chartInstance.canvas.parentNode.appendChild(tooltipEl);
              }

              tooltipEl.innerHTML = '<div>'+point.comment+'</div>';
              element.chartInstance.update();
            },
            onMouseout: function(e) {
              let element = this;
              element.options.label.content = point.comment.substr(0,5);
              let tooltipEl = document.getElementById('chartjs-tooltip-vertical');
              tooltipEl.parentNode.removeChild(tooltipEl);
              element.chartInstance.update();
            },
            label: {
              content: point.comment.substr(0,5),
              enabled: true,
              position: "top",
              xPadding: 16,
              yPadding: 10,
              yAdjust: 10,
            }
          })
        });
      }

      this.renderChart(
          this.linedatasets ? {
            labels: this.bardatasets.labels,
            datasets: [this.bardatasets,this.linedatasets]
          } : this.withLabels ? {
            labels: this.bardatasets[0].labels,
            datasets: this.bardatasets,
          } : {
            //labels: this.bardatasets[0].labels,
            datasets: this.bardatasets,
          },
          {
            responsive: true,
            borderSkipped: "bottom",
            maintainAspectRatio: this.aspectRatio,
            aspectRatio: this.aspectRatio ? 1.6 : false,
            tooltips: {
              enabled: this.linedatasets || this.withLabels ? true: false,
              callbacks: {
                title: function(tooltipItem, data) {
                  let label = Array.isArray(tooltipItem[0].xLabel) ? join(tooltipItem[0].xLabel, ' ') : tooltipItem[0].xLabel || '';
                  return label;
                }
              }
            },
            legend: {
              display: this.showLegend,
              position: this.isMobile ? 'bottom' : 'right',
              labels: {
                boxWidth: 14,
                padding: 20
              },
            },
            annotation: {
              events: ['click', 'dblclick', 'mouseover', 'mouseout'],
              annotations: pointArray,
            },
            scales: {
              yAxes: [
                {
                  afterTickToLabelConversion: function(scaleInstance) {

                    if(valueMax){
                      scaleInstance.ticks[0] = null;
                    }

                  },
                  ticks: {
                    beginAtZero: true,
                    max: valueMax ? valueMax : max ? max : 1,
                    //min: 0,
                    //suggestedMax: max
                  },
                  offset: true,
                  scaleLabel: {
                    display: true,
                    labelString: this.scaleLabelY
                  },
                },
              ],
              xAxes: [
                {
                  ticks: {
                    beginAtZero: true,
                    //suggestedMax: 50
                  },
                  offset: true,
                  scaleLabel: {
                    display: true,
                    labelString: this.scaleLabelX
                  },
                  maxBarThickness: 50
                },
              ],
            },
            animation: false,
            plugins: {
              datalabels: {
                backgroundColor: function(context) {
                  return context.dataset.backgroundColor;
                },
                borderRadius: 4,
                color: 'white',
                align: 'end',
                offset: 8,
                display: function(context) {
                  let index = context.dataIndex;
                  let value = context.dataset.data[index];
                  return value.y > 0 && context.dataset.type != 'bar';
                },
                formatter: function(value) {
                  return value.y;
                }
              }
            },
          },
      );
    },
  },
  watch: {
    linedatasets() {
      this.render();
    },
    bardatasets() {
      this.render();
    },
  },
};



// WEBPACK FOOTER //
// ./src/common/chart/Component/BarChart.js